import React from "react";

import { Box, Hidden } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

import { HelpIcon } from "./iconography";

export const SmartTipIcon = ({
  label,
  ml = 0,
  mt = 0,
  inline = false,
  absolute = false,
  top = 4,
  right = 4,
  alignMiddle = false,
  alignRight = true,
}) => {
  const theme = useTheme();
  if (!label) return null;

  // Treat numeric ml/mt as MUI spacing units so small numbers are visible.
  // If you truly want raw px, pass a string number (e.g. ml="12").
  const toPxNumber = (v) => {
    if (typeof v === "number") return theme.spacing(v);
    if (typeof v === "string") {
      const n = Number(v);
      return Number.isFinite(n) ? n : 0;
    }
    return 0;
  };

  // NOTE: When we're right-aligned (justifyContent: flex-end), margin-left won't push the
  // icon past the right edge. Use a separate "nudge" via translateX instead.
  const baseXOffset = toPxNumber(1.32);
  const xNudgePx = toPxNumber(ml) + baseXOffset;
  const inlineXOffsetPx = toPxNumber(ml);
  const yNudgePx = toPxNumber(mt);
  const baseLiftPx = theme.spacing(6.2); // ~48px, roughly one outlined TextField height
  const liftPx = baseLiftPx - yNudgePx;

  if (inline) {
    return (
      <Hidden xsDown>
        <Box
          style={{
            display: "inline-flex",
            cursor: "pointer",
            alignItems: alignMiddle ? "center" : "flex-start",
            verticalAlign: alignMiddle ? "middle" : "text-top",
            marginLeft: inlineXOffsetPx,
            marginTop: yNudgePx,
            position: "relative",
            zIndex: 1,
          }}
        >
          <HelpIcon
            id={label.toLowerCase().replace(/ /g, "-")}
            color="primary"
            fontSize="small"
          />
        </Box>
      </Hidden>
    );
  }

  if (absolute) {
    return (
      <Hidden xsDown>
        <Box
          style={{
            position: "absolute",
            top,
            right,
            display: "inline-flex",
            cursor: "pointer",
            alignItems: alignMiddle ? "center" : "flex-start",
            verticalAlign: alignMiddle ? "middle" : "text-top",
            zIndex: 1,
          }}
        >
          <HelpIcon
            id={label.toLowerCase().replace(/ /g, "-")}
            color="primary"
            fontSize="small"
          />
        </Box>
      </Hidden>
    );
  }

  return (
    <Hidden xsDown>
      <Box
        style={{
          width: alignRight ? "100%" : "auto",
          display: alignRight ? "flex" : "inline-flex",
          justifyContent: alignRight ? "flex-end" : "flex-start",
        }}
      >
        <Box
          style={{
            // marginTop: 0,
            display: "inline-flex", // Keeps the icon on the same line
            cursor: "pointer",
            alignItems: alignMiddle ? "center" : "flex-start",
            // Default = top alignment, overrideable via alignMiddle
            verticalAlign: alignMiddle ? "middle" : "text-top",
            ...(alignRight
              ? { transform: `translate(${xNudgePx}px, -${liftPx}px)` }
              : {}),
            ...(alignRight ? {} : { marginLeft: xNudgePx }),
            ...(alignRight
              ? {}
              : { transform: `translate(0px, -${liftPx}px)` }),
            marginBottom: `-${liftPx}px`, // don't add extra vertical space
            position: "relative",
            zIndex: 1,
          }}
        >
          <HelpIcon
            id={label.toLowerCase().replace(/ /g, "-")}
            color="primary"
            fontSize="small"
          />
        </Box>
      </Box>
    </Hidden>
  );
};
